import axios from '@axios'

export default {
  namespaced: true,
  state: {
    items: [],
    sources: [],
    formats: [],
  },
  getters: {},
  mutations: {
    ITEMS(state, value) {
      state.items = value
    },
  },
  actions: {
    fetchItems(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        const payload = { ...queryParams }

        // 1. Convertir les objets complexes en chaînes JSON, comme dans la requête GET originale.
        if (payload.filters && Array.isArray(payload.filters)) {
          payload.filters = payload.filters.map(filter => (typeof filter === 'object' && filter !== null ? JSON.stringify(filter) : filter))
        }
        Object.keys(payload).forEach(key => {
          if (key !== 'filters' && payload[key] && typeof payload[key] === 'object' && !Array.isArray(payload[key])) {
            payload[key] = JSON.stringify(payload[key])
          }
        })

        // 2. Encoder le payload en format x-www-form-urlencoded
        const formData = new URLSearchParams()
        for (const key in payload) {
          if (Object.prototype.hasOwnProperty.call(payload, key)) {
            const value = payload[key]
            if (Array.isArray(value)) {
              value.forEach(item => {
                formData.append(`${key}[]`, item)
              })
            } else if (value !== null && value !== undefined) {
              formData.append(key, value)
            }
          }
        }

        // 3. Envoyer en POST avec le header d'override
        axios
          .post('/manuscripts', formData, {
            headers: {
              'X-HTTP-Method-Override': 'GET',
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchItem(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/item/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addItem(ctx, itemData) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url: '/manuscripts',
          data: itemData,
          // eslint-disable-next-line no-unused-vars
          validateStatus: status => true,
        })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    quote(ctx, itemData) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url: '/quote-manuscripts',
          data: itemData,
          // eslint-disable-next-line no-unused-vars
          validateStatus: status => true,
        })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    actionOnItem(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url: payload.path,
          data: payload.item,
          // eslint-disable-next-line no-unused-vars
          validateStatus: status => true,
        })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteItem(ctx, id) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/manuscripts/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchCountries({ state }, options) {
      axios
        .get('/countries', { params: options })
        .then(response => {
          state.pays = response.data.data
        })
        .catch(error => console.log(error))
    },
    fetchStatuses({ state }, options) {
      axios
        .get('/statuses', { params: options })
        .then(response => {
          state.statuses = response.data.data
        })
        .catch(error => console.log(error))
    },
    fetchSources({ state }, options) {
      axios
        .get('/sources', { params: options })
        .then(response => {
          state.sources = response.data.data
        })
        .catch(error => console.log(error))
    },
    fetchFormats({ state }, options) {
      axios
        .get('/formats', { params: options })
        .then(response => {
          state.formats = response.data.data
        })
        .catch(error => console.log(error))
    },
  },
}
